const docsBaseUrl = `//${window.location.hostname}/`;

/**
 * 获取远程演示信息
 */
export const GET_SHOW = 'GET_SHOW';

/**
 * 获取远程演示信息
 */
export const GET_ROOM_INFO = 'GET_ROOM_INFO';

/**
 * 获取文档信息
 */
export const DOC_INFOS_GUEST = 'DOC_INFOS_GUEST';

/**
 * 获取文档信息
 */
export const GET_DOC_INFO = 'GET_DOC_INFO';


/**
 * 获得用户备注、头像，用于 用户列表获取
 */
export const GET_USER_AVATAR_MARKNAME = 'GET_USER_AVATAR_MARKNAME';

const CGI_PATH = {
    [GET_USER_AVATAR_MARKNAME]: `${docsBaseUrl}sdc/getcollabroomuserinfos`,
    [GET_SHOW]: `${docsBaseUrl}show-api/getshow`,
    [GET_ROOM_INFO]: `${docsBaseUrl}show-api/getroominfo`,
    [DOC_INFOS_GUEST]: `${docsBaseUrl}cgi-bin/online_docs/doc_infosguest`,
    /** 目前 enterprise 专用 */
    [GET_DOC_INFO]: `${docsBaseUrl}cgi-bin/online_docs/doc_info`,
};

export default CGI_PATH;
